/** 문제 카드 난이도 칩 숨김 설정의 브라우저 저장 키 (JCG-3917). 보기 숨기기와 같은 방식으로 저장한다. */
export const DIFFICULTY_HIDDEN_PREFERENCE_KEY = "jcg:difficulty-hidden";

/**
 * 숨김 설정이 실제로 적용되는지. 표시는 모두에게 무료이고 숨김은 프리미엄 이상만 적용한다
 * (이용권 만료 시 저장값과 무관하게 다시 보임). 이용권 판정 전(Clerk 로딩 중)에는 저장값을 우선해
 * 숨긴 사용자에게 칩이 잠깐 보이지 않게 한다. 칩(ProblemAnswer)과 설정 화면이 같은 규칙을 쓴다.
 */
export function isDifficultyHideActive(
  storedHidden: boolean,
  pass: { isPremiumOrAbove: boolean; isLoaded: boolean },
): boolean {
  return storedHidden && (!pass.isLoaded || pass.isPremiumOrAbove);
}
